import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import type {SliderOptionsRange} from '@Components/slider-options';
import {MorphType} from '@Libraries/fancy-text-library';

interface BaseFancyTextCurveUpOptionProps {
  morphAmount: number;
  updateMorphAmount(amount: number): void;
  updateMorphAmountEnded(amount: number): void;
  isSubOptionDisabled?: boolean;
  morphType?: MorphType;
}

export function BaseFancyTextCurveOption({isSubOptionDisabled = false, morphType = MorphType.CURVE_UP, ...props}: BaseFancyTextCurveUpOptionProps): ReactElement<any> | null {
  const onChangeHandler = (amount: number): void => {
    props.updateMorphAmount(amount);
  };

  const onChangeEndedHandler = (amount: number): void => {
    props.updateMorphAmountEnded(amount);
  };

  const getRange = (): SliderOptionsRange => {
    if (morphType === MorphType.CURVE_UP) {
      return {
        min: 0,
        max: 350,
      };
    }

    if (morphType === MorphType.CURVE_DOWN) {
      return {
        min: -350,
        max: 0,
      };
    }

    return {
      min: 1,
      max: 3,
    };
  };

  const getTransformationRange = (): SliderOptionsRange => {
    if (morphType === MorphType.CURVE_UP || morphType === MorphType.CURVE_DOWN) {
      return {
        min: 0,
        max: 100,
      };
    }

    return {
      min: 1,
      max: 3,
    };
  };

  return (
    <ContextualMenuSliderOptions
      id="curve-up"
      value={props.morphAmount}
      label={window.i18next.t('pmwjs_curve_amount')}
      range={getRange()}
      transformDisplay={getTransformationRange()}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEndedHandler}
      isDisabled={isSubOptionDisabled}
    />
  );
}
